import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { Divider } from "semantic-ui-react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Info from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import MuiSwitch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

export default function ProductView({ data, handleClose }) {
  const Switch = withStyles({
    switchBase: {
      "&$disabled": {
        color: data.allowBuyBack ? "#3f51b5" : "",
      },
      "&$disabled + $track": {
        backgroundColor: data.allowBuyBack ? "#3f51b5" : "",
        opacity: 0.5,
      },
    },
    track: {},
    disabled: {},
  })(MuiSwitch);

  return (
    <Grid container spacing={0}>
      <Grid item md={12}>
        <h1>PRODUCTO</h1>
        <Divider />
      </Grid>
      <Grid item md={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item md={5} xs={12}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Nombre"
                value={data.name}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={3} xs={12}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Tipo de Producto"
                value={data.productType?.text}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={2} xs={6}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Precio"
                value={data.price}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={2} xs={6}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Período Contrato"
                value={data.period}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={6} xs={12}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Compañia"
                value={data.company}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={4} xs={12}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Categoría"
                value={data.category}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={2} xs={6}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Centro de costo"
                type="number"
                value={data.costCenter}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12}>
            <FormControl fullWidth={true}>
              <TextField
                size="small"
                variant="outlined"
                label="Descripción"
                value={data.description}
                multiline
                rows={4}
                rowsMax={4}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>

          <Grid container spacing={3} style={{ marginTop: 1 }}>
            <Grid item md={4} xs={12}>
              <h4 style={{ display: "inline-flex" }}>
                ¿Permitir recomprar producto?
                <Tooltip
                  title="Activado: El producto podrá tener mas de un contrato vigente hacia un mismo cliente.
                              Desactivado: El producto podrá tener solo un contrato vigente hacia un cliente."
                >
                  <Info color="primary" />
                </Tooltip>
              </h4>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl fullWidth={true}>
                <Switch
                  color="primary"
                  defaultChecked={data.allowBuyBack}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                  mui
                />
              </FormControl>
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth={true}
                size="small"
                variant="outlined"
                label="Producto Externo"
                value={data.externalProduct}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} style={{ marginTop: 1 }}>
            <Grid item md={4} xs={12}>
              <h4 style={{ display: "inline-flex" }}>
                ¿Permitir facturar cliente corporativo?
                <Tooltip
                  title="Activado: El producto tendrá un medio de pago fijo de tipo efectivo.
                         Desactivado: El producto tendra el medio de pago seleccionado en cada contrato."
                >
                  <Info color="primary" />
                </Tooltip>
              </h4>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl fullWidth={true}>
                <Switch
                  color="primary"
                  defaultChecked={data.paymentMethodName != ""}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                  mui
                />
              </FormControl>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl fullWidth={true}>
                <TextField
                  size="small"
                  variant="outlined"
                  label="Factura Cliente Corporativo"
                  value={data.paymentMethodName}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          {Boolean(data?.vehicleTypes?.length) && (
            <>
              <Grid item md={12} xs={12}>
                <h2>Tipos de Vehículo</h2>
              </Grid>
              <Grid item md={12} xs={12}>
                <Autocomplete
                  multiple
                  filterSelectedOptions
                  options={data?.vehicleTypes}
                  getOptionLabel={(option) => option.text}
                  defaultValue={data?.vehicleTypes}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Grid>
            </>
          )}
          {Boolean(data?.features?.length) && (
            <>
              <h2>Características</h2>
              <Divider />
              <Grid container className="c-grid-results" style={{ padding: 0 }}>
                <Grid item md={12} xs={12}>
                  <TableContainer>
                    <Table className="c-table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>DETALLE</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data?.features?.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell>{item}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </>
          )}

          <Grid item md={12} xs={12}>
            <h2>Servicios</h2>
          </Grid>
          <Grid item md={12} xs={12}>
            <Autocomplete
              multiple
              filterSelectedOptions
              options={data.services}
              getOptionLabel={(option) => option.text}
              defaultValue={data.services}
              disabled
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Grid>

          {data.termsAndConditions && (
            <Grid item md={12} xs={12}>
              <h2>Términos y Condiciones</h2>
              <p>
                <a href={data.termsAndConditions} target="_blank">
                  Ver PDF
                </a>
              </p>
            </Grid>
          )}
          <Grid className="c-text-right" item md={12} xs={12}>
            <Button
              className="c-ml-5 c-grid-btn"
              color="primary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
